class IntegrationController extends AbstractController
	@register()
	@inject '$stateParams',
		'integrations'
		'translate'
		'LEGACY_INTEGRATIONS'

	initialize: ->
		@term = ''
		@showSearch = @integrations.length > 10
		@integrationId = @$stateParams.id

		for integration in @integrations
			integration.visible = true
			integration.is_legacy = @LEGACY_INTEGRATIONS.includes(integration.id)

			if integration.id == 'receipthero'
				integration.is_connected = true

	search: ->
		term = @term.toLowerCase()

		for integration in @integrations
			id = integration.id.toLowerCase()
			name = @translate('wbo.integration.' + integration.id + '.header').toLowerCase()

			integration.visible = term == '' || id.contains(term) || name.contains(term)
